"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remapThemeFontLineHeightKey = exports.addColorSubVariables = exports.addFontSubVariables = exports.toStylesheet = exports.emitCssVariable = exports.isColorStyleType = exports.isTextFontThemeVariable = exports.isColorTypeThemeVariable = exports.isThemeVariable = exports.isGlobalColor = exports.isGlobalFont = exports.isFontWeight = exports.isTextPreset = void 0;
var wix_site_theme_variables_1 = require("@wix/wix-site-theme-variables");
var utils_1 = require("./utils/utils");
var wixStyleFontUtils_1 = require("./utils/wixStyleFontUtils");
var isTextPreset = function (siteTextPresets, key) { return siteTextPresets[key]; };
exports.isTextPreset = isTextPreset;
var isFontWeight = function (key) { return ['LIGHT', 'MEDIUM', 'STRONG'].includes(key); };
exports.isFontWeight = isFontWeight;
var isGlobalFont = function (siteTextPresets, key) {
    return (0, exports.isTextPreset)(siteTextPresets, key) || (0, exports.isFontWeight)(key);
};
exports.isGlobalFont = isGlobalFont;
var isGlobalColor = function (key) { return key.startsWith('color-'); };
exports.isGlobalColor = isGlobalColor;
var isThemeVariable = function (key) { return key.startsWith('wst-'); };
exports.isThemeVariable = isThemeVariable;
var isColorTypeThemeVariable = function (key) { return key.endsWith('-color'); };
exports.isColorTypeThemeVariable = isColorTypeThemeVariable;
var isTextFontThemeVariable = function (key) { return key.endsWith('-font') && wix_site_theme_variables_1.TextVariableNames[key]; };
exports.isTextFontThemeVariable = isTextFontThemeVariable;
var isColorStyleType = function (styleType) { return styleType.toLowerCase().endsWith('color'); };
exports.isColorStyleType = isColorStyleType;
var emitCssVariable = function (paramKey, paramValue, prefix) {
    if (prefix === void 0) { prefix = ''; }
    var normalizedKey = paramKey.replace(/:/g, '-');
    var key = "--".concat(prefix ? "".concat(prefix, "-") : '').concat(normalizedKey);
    return {
        key: key,
        value: paramValue,
    };
};
exports.emitCssVariable = emitCssVariable;
var toStylesheet = function (definitions) {
    return Object.entries(definitions)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, ": ").concat(value, ";");
    })
        .join('\n');
};
exports.toStylesheet = toStylesheet;
var addFontSubVariables = function (_a, target) {
    var cssVariable = _a.cssVariable, font = _a.font, _b = _a.addTextDecoration, addTextDecoration = _b === void 0 ? false : _b;
    target["".concat(cssVariable.key, "-style")] = font.style;
    target["".concat(cssVariable.key, "-variant")] = font.variant;
    target["".concat(cssVariable.key, "-weight")] = font.weight;
    target["".concat(cssVariable.key, "-size")] = (0, utils_1.withDefaultPxUnit)(font.size);
    target["".concat(cssVariable.key, "-line-height")] = (0, utils_1.withDefaultPxUnit)(font.lineHeight);
    target["".concat(cssVariable.key, "-family")] = wixStyleFontUtils_1.wixStylesFontUtils.stringifyFontFamily(font.family);
    if (addTextDecoration) {
        target["".concat(cssVariable.key, "-text-decoration")] = 'underline' in font && font.underline ? 'underline' : 'none';
    }
};
exports.addFontSubVariables = addFontSubVariables;
var addColorSubVariables = function (_a, target) {
    var cssVariable = _a.cssVariable, rgbParts = _a.rgbParts;
    target["".concat(cssVariable.key, "-rgb")] = rgbParts.rgb;
    target["".concat(cssVariable.key, "-opacity")] = rgbParts.opacity;
};
exports.addColorSubVariables = addColorSubVariables;
var remapThemeFontLineHeightKey = function (baseKey, target) {
    var fromKey = "".concat(baseKey, "-line-height");
    var toKey = "".concat(baseKey.replace(/-font$/, ''), "-line-height");
    if (toKey !== fromKey && fromKey in target) {
        var value = target[fromKey];
        delete target[fromKey];
        target[toKey] = value;
    }
};
exports.remapThemeFontLineHeightKey = remapThemeFontLineHeightKey;
//# sourceMappingURL=css-variables.utils.js.map